import { motion } from "framer-motion";
import { Reveal, Overline } from "./Reveal";
import { GALLERY_SHOTS } from "../data/content";

// 13-tile bento layout — spans/ratios chosen to create rhythmic tetris tension.
const LAYOUT = [
  { span: "lg:col-span-8", ratio: "aspect-[16/10]" },
  { span: "lg:col-span-4", ratio: "aspect-[4/5]" },
  { span: "lg:col-span-4", ratio: "aspect-[4/5]" },
  { span: "lg:col-span-4", ratio: "aspect-[4/5]" },
  { span: "lg:col-span-4", ratio: "aspect-[4/5]" },
  { span: "lg:col-span-6", ratio: "aspect-[3/2]" },
  { span: "lg:col-span-6", ratio: "aspect-[3/2]" },
  { span: "lg:col-span-4", ratio: "aspect-[4/5]" },
  { span: "lg:col-span-8", ratio: "aspect-[16/10]" },
  { span: "lg:col-span-4", ratio: "aspect-[4/5]" },
  { span: "lg:col-span-4", ratio: "aspect-[4/5]" },
  { span: "lg:col-span-4", ratio: "aspect-[4/5]" },
  { span: "lg:col-span-12", ratio: "aspect-[16/7]" },
];

export const Gallery = () => {
  const tiles = GALLERY_SHOTS.map((src, i) => ({
    src,
    ...LAYOUT[i % LAYOUT.length],
  }));

  return (
    <section
      className="relative mx-auto max-w-[1400px] px-6 py-28 lg:px-10 lg:py-40"
      data-testid="gallery-section"
    >
      <div className="mb-16 max-w-2xl">
        <Reveal>
          <Overline>Behind The Scenes</Overline>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-6 font-serif text-4xl tracking-tight text-white sm:text-5xl">
            On Set &amp; In The Edit
          </h2>
        </Reveal>
      </div>

      <div className="grid grid-cols-12 items-start gap-5 lg:gap-6">
        {tiles.map((t, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, scale: 0.98, y: 30 }}
            whileInView={{ opacity: 1, scale: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{
              duration: 0.9,
              delay: (i % 3) * 0.06,
              ease: [0.22, 1, 0.36, 1],
            }}
            className={`group col-span-12 overflow-hidden rounded-sm border border-white/5 ${t.span} ${t.ratio}`}
            data-testid={`gallery-shot-${i}`}
          >
            <img
              src={t.src}
              alt={`Behind the scenes ${i + 1}`}
              loading="lazy"
              referrerPolicy="no-referrer"
              className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
            />
          </motion.div>
        ))}
      </div>
    </section>
  );
};
